// extracted by mini-css-extract-plugin
export default {"toastMessage":"Utils_toastMessage__CEiT6","contactText":"Utils_contactText__mBf+7"};